"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPalette = void 0;
const clusterHistogram_1 = require("./clusterHistogram");
const greedyClusterMerge_1 = require("./greedyClusterMerge");
const kmeans_1 = require("./kmeans");
const lab_1 = require("./lab");
function getPalette(imageData, numberOfColors) {
    const labData = (0, lab_1.srgbToLabArray)(imageData.data);
    const k = Math.max(32, numberOfColors);
    const initialClusters = (0, clusterHistogram_1.clusterHistogram)(labData, 6, k);
    const clusters = (0, kmeans_1.kmeans)(labData, initialClusters, 8).filter((c) => c.count > 0);
    return (0, greedyClusterMerge_1.greedyClusterMerge)(clusters, numberOfColors)
        .map((cluster) => {
        const srgb = (0, lab_1.labToSrgb)({ l: cluster.x, a: cluster.y, b: cluster.z });
        return [
            srgb.r * 255,
            srgb.g * 255,
            srgb.b * 255,
        ];
    });
}
exports.getPalette = getPalette;
